import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "ShareTokenList" })
export default class ShareTokenList extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public shareTokens: any[] = [];
    public selectedShareTokens: any[] = [];
    public isAllItemsSelected: boolean = false;

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingShareToken_GetShareTokens)).data;
        this.shareTokens = result;

        this.isLoading = false;
    }

    public selectItem() {
        this.isAllItemsSelected = false;
    }

    public selectAllItems() {
        this.selectedShareTokens = [];

        if (!this.isAllItemsSelected) {
            for (let item of this.shareTokens) {
                this.selectedShareTokens.push(item);
            }

            this.isAllItemsSelected = true;
        }
    }

    public async deleteShareToken(token: any) {
        if (confirm(this.localizer.get("App.FileSharing.DeleteShareTokenConfrim", token.email)) == true) {
            try {
                var shareTokenIdMasters = [];
                shareTokenIdMasters.push(token.idMaster);

                await Axios.post(this.routes.MyBremboPartsFileSharingShareToken_RemoveShareToken, { shareTokenIdMasters: shareTokenIdMasters });

                location.reload();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.$store.dispatch("bremboToastStore/onAddToast", { message: FormHelper.getValidationErrors(error.response.data)[0].message, type: "Error" });
                }
            }
        }
    }

    public async deleteShareTokens() {
        if (confirm(this.localizer.get("App.FileSharing.DeleteShareTokensConfrim")) == true) {
            try {
                await Axios.post(this.routes.MyBremboPartsFileSharingShareToken_RemoveShareToken, { shareTokenIdMasters: this.selectedShareTokens.map(x => x.idMaster) });

                location.reload();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.$store.dispatch("bremboToastStore/onAddToast", { message: FormHelper.getValidationErrors(error.response.data)[0].message, type: "Error" });
                }
            }
        }
    }
}